module.exports = __webpack_public_path__ + "img/logo_howert.27de60da.png";